import React from 'react';
import Header from '../../Components/Header';
import RailSearch from './RailSearch';

const Rail = () => (
  <>
     <Header></Header>
   <section className='Rail_top_banner'>
      <RailSearch />
    </section>
    <section class="footer_top"> 
		<div class="container">
		<div class="_toprflcont mb-8">
			<div class="_hdrtxt">Quick Links </div>
		</div>
     <div class="col-md-12">
        <div class="d-flex-bus">
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Lucknow.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Lucknow</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Chandigarh.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Chandigarh</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Dehradun.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Dehradun</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Ahemdabad.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Ahemdabad</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Indore.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Indore</h5>
                </a>
            </div>
           
           
        </div>
     </div>
           
            
        </div>    
    </section>
  </>

);

export default Rail;
